import APIClient from './index';
import _ from 'lodash';

export const sendSimulatedMessage = ({ message, phoneNumber }) => {
  return new Promise((resolve, reject) => {
    APIClient.post('/ConciergeSimulator/send', { message, phoneNumber })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getSimulatorThread = phoneNumber => {
  return new Promise((resolve, reject) => {
    APIClient.get(`/ConciergeSimulator/thread?phoneNumber=${encodeURIComponent(phoneNumber)}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
